import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
    selector: 'pui-dialog-confirm',
    templateUrl: 'confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class PuiConfirmDialogComponent {
    title: string;
    message: string;
    cancelButton: string = 'Cancel';
    acceptButton: string = 'Accept';

    constructor(private dialogRef: MdDialogRef<PuiConfirmDialogComponent>) { }

    cancel(): void {
        this.dialogRef.close(false);
    }

    accept(): void {
        this.dialogRef.close(true);
    }
}
